import React from "react";
import { useUser } from "../../services/useUser";

const CenterSection: React.FC = () => {
  const user = useUser();

  return (
    <div className="grow text-right px-6" title={user?.attributes?.email}>
      Welcome! {user?.attributes?.name}
    </div>
  );
};

export default CenterSection;
